import PropTypes from "prop-types";
import React, { useState } from "react";

import KnowledgeCenterCard from "~/components/KnowledgeCenterCard";
import ThoughtLeadershipCard from "~/components/ThoughtLeadershipCard";
import SectionHeading from "~/components/SectionHeading";

import Button from "~/components/buttons/Button";

import Col from "~/components/layout/Col";
import ContentContainer from "~/components/layout/ContentContainer";
import Row from "~/components/layout/Row";
import SectionWrapper from "~/components/layout/SectionWrapper";

import useStringTranslation from "~/hooks/translations/useStringTranslation";

const KnowledgeCenter = ({
    cards,
    backgroundColor = "white",
    linkLabel = "",
    linkUrl = "",
    linkAriaLabel = "",
    noMarginBottom = false,
    title = "",
    withBorder = false,
    sectionId = "",
    columns = `3`,
    cardStyle = "default",
    useLoadMore = false,
}) => {
    const [numberToShow, setNumberToShow] = useState(
        useLoadMore ? 3 : cards.length,
    );

    const { loadMoreText } = useStringTranslation([
        { text: "Load More", handle: "loadMoreText" },
    ]);

    return cards.length ? (
        <SectionWrapper
            withPadding={backgroundColor === "gray"}
            {...{ sectionId, backgroundColor, noMarginBottom, withBorder }}
        >
            <ContentContainer>
                {title || (linkLabel && linkUrl) ? (
                    <Row>
                        <Col>
                            <SectionHeading
                                {...{ title }}
                                linkType="button"
                                links={
                                    linkLabel && linkUrl
                                        ? [
                                              {
                                                  linkLabel,
                                                  linkUrl,
                                                  linkAriaLabel,
                                              },
                                          ]
                                        : []
                                }
                            />
                        </Col>
                    </Row>
                ) : null}
                <Row>
                    {cards.slice(0, numberToShow).map(({ id, ...props }) => (
                        <Col
                            key={id}
                            flex
                            sm={1 / (parseInt(columns) > 1 ? 2 : 1)}
                            md={1 / parseInt(columns)}
                        >
                            {cardStyle === "image-author" ? (
                                <ThoughtLeadershipCard {...{ id }} {...props} />
                            ) : (
                                <KnowledgeCenterCard {...{ id }} {...props} />
                            )}
                        </Col>
                    ))}
                    {numberToShow < cards.length ? (
                        <Col style={{ textAlign: "center" }}>
                            <Button
                                color="purple"
                                onClick={() =>
                                    setNumberToShow(numberToShow + 3)
                                }
                            >
                                {loadMoreText}
                            </Button>
                        </Col>
                    ) : null}
                </Row>
            </ContentContainer>
        </SectionWrapper>
    ) : null;
};

KnowledgeCenter.propTypes = {
    backgroundColor: PropTypes.oneOf(["white", "gray"]),
    cards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    linkLabel: PropTypes.string,
    linkAriaLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    noMarginBottom: PropTypes.bool,
    title: PropTypes.string,
    withBorder: PropTypes.bool,
    sectionId: PropTypes.string,
    columns: PropTypes.oneOf([`1`, `2`, `3`]),
    cardStyle: PropTypes.oneOf([`default`, `image-author`]),
    useLoadMore: PropTypes.bool,
};

export default KnowledgeCenter;
